/* eslint-disable import/prefer-default-export */

/**
 * Function for displaying the live chat button
 */
export const init = () => {
    const liveChatButton = document.getElementById('ebcss-chat-button');
    if (liveChatButton !== null) {
        liveChatButton.addEventListener('click', e => {
            e.preventDefault();
            const isChatOpen = sessionStorage.getItem('chat-already-open');
            if (window.dataLayer && isChatOpen !== 'true') {
                window.dataLayer.push({
                    event: 'start_chat'
                });
                sessionStorage.setItem('chat-already-open', 'true');
            }
        });
    }
};
